import React from 'react';
import {SliderDialog} from "@components/form/SliderDialog";
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FormLabel from "@material-ui/core/FormLabel";
import Typography from '@material-ui/core/Typography';
import ResponsiveComponent from "@components/form/ResponsiveComponent";
import Button from "@material-ui/core/Button";
import {PermissionModule} from '@components/common/permission/PermissionModule';
import {PermissionModuleGroup} from '@components/common/permission/PermissionModuleGroup';
import {NewTtnContainer} from '@components/modules/novaposhta/modals/new-ttn/new-ttn.container';
import {Input} from '@components/form/Input';
import {Price} from '~/components/form/formatting/Price';
import {orderHistoryEventTypes, orderHistoryEventNames} from './enum/constants';
import {BasePhoneNumber} from '@components/common/phone/base-phone-call';
import dayjs from "dayjs";
import RemoteAutocompleteWithSearch from "@components/form/RemoteAutocompleteWithSearch";
import FileCopyIcon from '@material-ui/icons/FileCopy';
import Grid from "@material-ui/core/Grid";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import InputAdornment from "@material-ui/core/InputAdornment";
import SendIcon from '@material-ui/icons/Send';
import {NewTaskContainer} from '@components/user-tasks/modals/new-task/new-task.container';
import {CombineOrdersContainer} from "@components/orders/modals/combine-orders/combine-orders.container";
import {PRODUCTS_SHOWCASE_ROOT} from "~/router/routes";
import {checkModuleGroup} from '~/utils/permissions';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import {MaterialTableComponent} from "@components/form/MaterialTableComponent";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import {LabelButton} from "@components/common/buttons/LabelButton";
import {TooltipButton} from "@components/common/buttons/TooltipButton";
import {Helmet} from "react-helmet";
import { NewOrderContainer } from '@components/orders/modals/new-order/new-order.container';
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@components/form/Checkbox";
import {NewDocumentContainer} from "@components/modules/docs-templates/modals/new-document/new-document.container";
import RemoteAutocompleteWithInput from "@components/form/RemoteAutocompleteWithInput";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import {ShowMoreText} from "@components/form/ShowMoreText";
import {statusActions} from '@components/orders/constants/index';
const ImagesSlider = React.lazy(() => import("@components/form/ImagesSlider"));
import {Select} from '@components/form/Select';
import {NewTtnContainer as UkrposhtaTtnContainer} from "@components/modules/ukrposhta/modals/new-ttn/new-ttn.container";

export class OrderDetailsComponent extends React.Component {

    initNewOrderCostRowState = {
        isOpen: false,
        cost: '',
        title: '',
        errors: {},
    }

    state = {
        open: this.props.open || false,
        isDataLoading: true,
        order: {},
        tasks: [],
        clientOrders: {},
        selectedClientOrders: [],
        bankTransactions: {},
        newOrderCostRow: this.initNewOrderCostRowState,
        comment: '',
        message: {
            id: null,
            value: null,
            label: '',
        },
    };

    componentDidMount() {
        if (this.props.disableOpenButton) {
            this.getData();
        }
    }

    componentDidUpdate(prevState, prevProps) {
        if (this.props.orderId && this.state.open && this.state.open != prevProps.open) {
            this.getData();
        }
    }

    getData = () => {
        Promise.all([
            this.props.getOrderDetails(this.props.orderId),
            this.props.getOrderTasksList(this.props.orderId),
            this.props.getAllClientOrders(this.props.orderId),
            this.props.getOrderBankTransactions(this.props.orderId),
        ]).then(values => {
            const [data, tasks, clientOrders, bankTransactions] = values;
            this.setState({
                isDataLoading: false,
                order: data.data,
                clientOrders: clientOrders.data,
                tasks: tasks.data,
                bankTransactions: bankTransactions.data,
            });
        });
    };

    ttnCreated = ({ data }) => {
        this.setState({...this.state, order: {
                ...this.state.order,
                ttn: data.ttn,
                // delivery_details_novaposhta: {
                //     ...this.state.order.delivery_details_novaposhta,
                //     DateTime: data.delivery_date,
                //     Cost: data.cost,
                // }
            }})
    }

    updateComment = () => {
        let {comment, order: {history}} = this.state;
        history.push({
            created_at: new Date,
            data: {
                data: {comment: comment},
                message: "Добавлен комментарий",
            },
            event: "comment",
            id: history[history.length - 1].id + 1,
            order_id: this.state.order.id,
        })
        this.setState({...this.state, comment: '', order: {...this.state.order, history: history}});
        this.props.updateOrderComment(this.state.order.id, comment);
    }

    attachOrderFile = (e) => {
        e.preventDefault();
        let {order: {history}} = this.state;
        const {attachOrderFile} = this.props;
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            history.push({
                created_at: new Date,
                data: {
                    data: {
                        fileName: file.name,
                        type: file.type,
                    },
                    message: "Добавлен файл",
                },
                file: reader.result,
                event: "file",
                id: history[history.length - 1].id + 1,
                order_id: this.state.order.id,
            })
            this.setState({...this.state, order: {...this.state.order, history: history}});
            attachOrderFile(this.state.order.id, {
                file: reader.result,
                fileType: file.type,
                fileName: file.name
            });
        };
        reader.readAsDataURL(file);
    }

    sendOrderAction = async () => {
        const {sendOrderAction} = this.props;
        await sendOrderAction(this.state.order.id, this.state.message.id);
    }

    addTask = (data) => {
        let {tasks} = this.state;
        tasks.push(data)
        this.setState({...this.state, tasks: tasks});
    }

    orderHistoryDataRender = (id, context, eventType, data, file) => {
        try {
            switch (eventType) {
                case orderHistoryEventNames.call:
                    return (<>
                    <div>Статус звонка: {data.status}</div>
                    {checkModuleGroup(context.modules, 'voip') && data.id && <>
                        {!data.url
                            ? <span
                                style={{cursor: 'pointer', color: '#3f51b5'}}
                                onClick={(e) => {
                                    this.props.getCallUrl(data.id).then((response) => {
                                        if (response.url) {
                                            let {history} = this.state.order;
                                            this.setState({
                                                ...this.state,
                                                order: {
                                                    ...this.state.order,
                                                    history: history.map(row => row.id === id ? {...row, data: {...row.data, url: response.url}} : row)
                                                }
                                            });
                                        }
                                    });
                                }}
                            >Прослушать звонок</span>
                            : <audio
                                controls
                                autoPlay
                                src={data.url}
                            >
                                Ваш браузер не поддерживает
                                <code>audio</code> элемент.
                            </audio>
                        }
                    </>}
                </>)
                case orderHistoryEventNames.created:
                    return data.data.source !== 'default' ? `Источник: ${data.data.source}` : ''
                        + (data.data?.message && !!data.data.message ? ' Комментарий: ' + data.data.message : '')
                case orderHistoryEventNames.deleted:
                    return `Удален: ${data.data?.user || ''}`
                case orderHistoryEventNames.status:
                    return `Изменен на "${context.statuses.filter(status => status.id == data.data.status)[0].name}"`
                case orderHistoryEventNames.sync:
                    return data?.data?.details || ''
                case orderHistoryEventNames.ttn:
                    return `ТТН: ${data.data.ttn}`
                case orderHistoryEventNames.update_product:
                    return `Добавлен товар ${data.data.variation.product?.title} ${data.data.variation.barcode ? 'b/c: ' + data.data.variation.barcode : ''} ${data.data.variation.sku ? 'sku: ' + data.data.variation.sku : ''}`
                case orderHistoryEventNames.packing:
                    return `Упаковка`
                case orderHistoryEventNames.comment:
                    return `${data.data.comment}`
                case orderHistoryEventNames.file: return (<>
                    {(() => {
                        switch (data.data.type) {
                            case 'application/pdf':
                                return <Grid container spacing={1} alignItems={'center'}>
                                    <Grid item>
                                        <IconButton onClick={(e) => window.open(file, '_blank')}><FileCopyIcon /></IconButton>
                                    </Grid>
                                    <Grid item>
                                        <Typography variant={'body2'}>{data.data.fileName}</Typography>
                                    </Grid>
                                </Grid>
                            default:
                                // @todo: add image slider from BE-467
                                return <img style={{width: '150px', height: '150px', objectFit: 'contain'}} alt={data.data.fileName} src={file}/>
                        }
                    })(data.data)}
                </>)
                case orderHistoryEventNames.assign_bank_transaction:
                    return `${data.data.transaction_sum} от ${data.data.transaction_date}`
                case orderHistoryEventNames.unassign_bank_transaction:
                    return `${data.data.transaction_sum} от ${data.data.transaction_date}`
                case orderHistoryEventNames.pipeline:
                    return `Сообщение: ${data.data.message}`
                case orderHistoryEventNames.sms:
                    return (<ShowMoreText
                        text={`Сообщение: "${data.data.message}" отправлено на номер: ${data.data.phone}`}
                        limit={140}
                    />)
            }
        } catch (e) {
            return '---';
        }
    }

    createOrderCost = async () => {
        let response = await this.props.createOrderCost(this.state.order.id, {...this.state.newOrderCostRow});
        if (response.errors) {
            this.setState({...this.state, newOrderCostRow: {...this.state.newOrderCostRow, errors: response.errors}});
        } else {
            this.setState({
                ...this.state,
                newOrderCostRow: this.initNewOrderCostRowState,
                order: {...this.state.order, costs_list: [...this.state.order.costs_list, response.data]},
            });
        }
    }

    onOrderUpdate = (response) => {
        this.setState({...this.state, order: {...this.state.order, ...response.data, products: response.data.products}});

        if (this.props.tableRef) {
            this.props.tableRef.current.onQueryChange();
        } 
    }

    onOrdersCombine = (response) => {
        if(response.data.id !== this.props.orderId){
            this.setState({open: false});
            return;
        }
        let {selectedClientOrders, clientOrders, order} = this.state;

        let newClientOrders = clientOrders.filter(newOrder => !selectedClientOrders.includes(newOrder.id) || newOrder.id === order.id);

        this.setState({...this.state, 
            order: {...this.state.order, ...response.data, products: response.data.products},
            clientOrders : newClientOrders,
            selectedClientOrders : [] 
        });

        if (this.props.tableRef) {
            this.props.tableRef.current.onQueryChange();
        } 
    }

    getOrderStatuses = () => {
        let statuses, company_statuses = this.props.context.statuses;
        if (this.state.order.pipeline_id) {
            let pipeline_statuses = this.state.order.pipeline.pipeline_statuses.filter(_status => _status.is_enabled);
            statuses = pipeline_statuses.map(status => {
                return {
                    value: status.status_id,
                    label: company_statuses.filter(_status => _status.id === status.status_id)[0].name
                }
            });
        } else {
            statuses = company_statuses.map(status => { return {value: status.id, label: status.name } });
        }

        return statuses;
    };

    onOrderStatusChange = (value) => {
        let company_statuses = this.props.context.statuses;
        this.setState({
            ...this.state,
            order: {
                ...this.state.order,
                status: company_statuses.filter(status => status.id == value)[0]
            }});

        if (this.props.tableRef) {
            this.props.tableRef.current.onQueryChange();
        }
    };

    renderPipelineData = () => {
        const {classes} = this.props;
        const {pipeline_fields, pipeline} = this.state.order;

        return (<Grid item xs={12} style={{padding: '0px'}}>
            <FormLabel style={{margin: '40px 0 10px'}} component="legend">Настройки заказа и дополнительные поля</FormLabel>

            <div className={classes.order_details_pipeline}>
                <Grid container spacing={1} className={classes.order_details_pipeline_name}>
                    <Grid item xs={6} md={4}>
                        Пайплайн заказа
                    </Grid>
                    <Grid item xs={6} md={8}>
                        {pipeline.name}
                    </Grid>
                </Grid>

                {pipeline_fields.map(pipelineField => {
                    let field = pipeline.fields.filter(field => field.id == pipelineField.pipeline_field_id)[0];
                    return (<Grid container spacing={1} className={classes.order_details_pipeline_row}>
                        <Grid item xs={6} md={4}>
                            {field.name}
                        </Grid>
                        <Grid item xs={6} md={8}>
                            {pipelineField.value}
                        </Grid>
                    </Grid>)
                })}
            </div>
        </Grid>)
    }

    getPublicLink = async () => {
        let response = await this.props.getOrderShortlink(this.props.orderId);
        if (response.url) {
            window.open(response.url);
        }
    }

    getDocumentType = (fileName) => {
        switch (fileName.split('.').pop()) {
            case 'xlsx':
            case 'xls':
                return  'excel';

            case 'doc':
            case 'docx':
                return 'docx';
        }
    };

    onDocumentCreate = (document) => {
        this.setState({
            ...this.state,
            order: {...this.state.order, documents: [...this.state.order.documents, document]}
        });
    };

    getModalIcon = () => {
        if (!this.props.disableOpenButton) {
            if (this.props.customOpenButton) {
                return <div onClick={e => this.setState({open : true, isDataLoading: true})}>{this.props.customOpenButton}</div>
            }

            return <ResponsiveComponent
                xs={<Button
                    variant="outlined"
                    color="primary"
                    onClick={(e) => this.setState({open: true, isDataLoading: true})}
                >
                    Детали
                </Button>}

                md={<IconButton
                    color={'inherit'}
                    onClick={(e) => this.setState({open: true, isDataLoading: true})}
                >
                    <MoreVertIcon/>
                </IconButton>}
            />
        }

        return null;
    };

    isEnabledClientOrder = (clientOrder) => {
        let { order } = this.state;
        return statusActions.includes(clientOrder.status.action) && !clientOrder.ttn && clientOrder.currency_id === order.currency_id;     
    }

    handleSelectAllClick = (event) => {
        let { clientOrders } = this.state;
        let newSelected = [];
        if (event.target.checked) {
            newSelected = clientOrders.filter(order => this.isEnabledClientOrder(order)).map(order => order.id);
        }
        this.setState({
            ...this.state,
            selectedClientOrders : newSelected
        });
    }

    handleClick = (id) => {
        let {selectedClientOrders} = this.state;

        let index = selectedClientOrders.indexOf(id);
        if (index !== -1) {
            selectedClientOrders.splice(index, 1);
        }
        else{
            selectedClientOrders.push(id);
        }
        this.setState({
            ...this.state,
            selectedClientOrders : selectedClientOrders
        });
    }

    render() {
        const {order, clientOrders,  selectedClientOrders, tasks, bankTransactions} = this.state;
        const {classes, context} = this.props;

        return (<>
            {this.state.open && <Helmet>
                <title>{`${order.company_order_id ? 'Детали заказа #' + order.company_order_id + ' | ' : ''}BeClear CRM`}</title>
            </Helmet>}

            <SliderDialog
                open={this.state.open}
                onClose={(e) => {
                    this.setState({open: false});
                    this.props.onClose && this.props.onClose();
                }}
                maxWidth={'md'}
                title={`Детали заказа № ${order.company_order_id}`}
                headerActions={[
                    <NewOrderContainer
                        orderId={order.id}
                        pipelines={this.props.pipelines}
                        onSubmitRedirect={(response) => this.onOrderUpdate(response)}
                    />,
                    <PermissionModule name={'clientorders'}>
                        <TooltipButton
                            title="Поделиться"
                            icon={<ShareOutlinedIcon color={'primary'} />}
                            onClick={this.getPublicLink}
                        />
                    </PermissionModule>
                ]}
                icon={this.getModalIcon()}
                defaultAction={false}
                isLoading={this.state.isDataLoading}
            >
                {Object.keys(order).length > 0 &&
                    <Grid container spacing={3} className={classes.gridContainer}>
                        <Grid item xs={12} sm={6} md={4} style={{padding: 0}}>
                            <FormLabel style={{margin: '0 0 20px'}} component="legend">Статус</FormLabel>
                            <Select
                                name={'status'}
                                options={this.getOrderStatuses()}
                                value={order.status.id}
                                fullWidth
                                variant={'outlined'}
                                size={'small'}
                                margin={'none'}
                                disabled={!!order.deleted_at}
                                onClick={e => e.stopPropagation()}
                                onChange={async ({target: {value}}) => {
                                    await this.props.updateOrderStatus(order.id, value);
                                    this.onOrderStatusChange(value);
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} style={{padding: 0}}>
                            <FormLabel style={{margin: '40px 0 20px'}} component="legend">Клиент</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={[order.client || {}]}
                                columns={[
                                    {
                                        title: 'Имя',
                                        field: 'name',
                                    },
                                    {
                                        title: 'Телефон',
                                        field: 'phones',
                                        render: (row) => <>
                                            {row.phones?.map((phoneObject, index) =>
                                                <div
                                                    style={{
                                                        margin: `${index === 0 ? '0px' : '8px' } 0px ${index === row.phones.length - 1 ? '0px' : '4px' }`
                                                    }}
                                                >
                                                    <BasePhoneNumber
                                                        phone={phoneObject.phone}
                                                        orderId={order.id}
                                                        do_not_disturb={order.do_not_disturb}
                                                    />
                                                </div>
                                            )}
                                        </>,
                                    },
                                    {
                                        title: 'E-mail',
                                        field: 'email',
                                    },
                                    {
                                        title: 'Score',
                                        field: 'score',
                                        render: row => row.score?.toFixed(2)
                                    },
                                    {
                                        title: 'Тeги',
                                        field: 'tags',
                                        render: (row) => <>
                                            {!!row.tags && row.tags.map((tag, index) =><div
                                                style={{
                                                    margin: `${index === 0 ? '0px' : '8px' } 0px ${index === row.tags.length - 1 ? '0px' : '4px' }`
                                                }}
                                            >
                                                {tag}
                                            </div>)}
                                        </>,
                                    },
                                    {
                                        title: 'Комментарий',
                                        field: 'comment',
                                    },
                                ]}
                                actions={[]}
                            />
                        </Grid>

                        <PermissionModuleGroup
                            type={'sms'}
                        >
                            <Grid item xs={12} sm={8}>
                                <FormLabel className={classes.massageFormLable} style={{margin: '40px 0 20px'}} component="legend">Отправка сообщения</FormLabel>
                                <div className={classes.inputWithIconButton}>
                                    <RemoteAutocompleteWithSearch
                                        name={'message'}
                                        url={'/api/v1/message-templates/autocomplete'}
                                        label="Шаблон сообщения"
                                        value={this.state.message.value}
                                        onChange={(e, target) => this.setState({...this.state, message: {id: target?.id, value: target?.value, label: target?.label}})}
                                        variant={'outlined'}
                                        size={'small'}
                                        margin={'normal'}
                                    />
                                        <IconButton style={{marginTop: '5px'}} onClick={(e) => {
                                            if(this.state.message && this.state.message.value) this.sendOrderAction();
                                        }}>
                                            <SendIcon />
                                        </IconButton>
                                </div>
                            </Grid>
                        </PermissionModuleGroup>

                        <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '40px 0 20px'}} component="legend">Товары</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={order.products}
                                columns={[
                                    {
                                        title: 'SKU',
                                        field: 'sku',
                                        render: (row) => row.variation.sku,
                                        mobileCellProps: {
                                            style: {
                                                backgroundColor: '#fafafa'
                                            },
                                        }
                                    },
                                    {
                                        title: 'Штрих-код',
                                        field: 'barcode',
                                        render: (row) => row.variation.barcode,
                                    },
                                    {
                                        title: 'Фото',
                                        field: 'image',
                                        render: row => row.variation.product.image.length !== 0 ? <ImagesSlider
                                        images={row.variation.product.image}
                                     />  : <div style={{width: '100px', height: '100px', background: '#f5f5f5'}} />
                                    },
                                    {
                                        title: 'Название',
                                        field: 'name',
                                        render: (row) => <div
                                            style={{cursor: context.modules.showcase.enabled ? 'pointer' : 'default'}}
                                            onClick={e => context.modules.showcase.enabled && window.open(PRODUCTS_SHOWCASE_ROOT + btoa(context.company.id) + `?product=${row.variation.product.id}`, '_blank')}
                                        >
                                            <div>{row.variation.product.title}</div>
                                            {row.variation.characteristic && row.variation.characteristic.group
                                                ? (<div
                                                    style={{fontStyle: 'italic'}}>{row.variation.characteristic.group.name}: {row.variation.characteristic.name}</div>)
                                                : undefined
                                            }
                                            {!!row.comment ? (<div style={{fontStyle: 'italic'}}>{row.comment}</div>) : undefined}
                                        </div>,
                                    },
                                    {
                                        title: 'Количество',
                                        field: 'amount',
                                    },
                                    {
                                        title: 'Общая цена',
                                        field: 'total_price',
                                        render: (row) => <Price value={row.total_price} />
                                    },
                                ]}
                                customLastRow={(tableClasses) => <ResponsiveComponent
                                    xs={<>
                                        <TableRow>
                                            <TableCell colSpan={2} style={{backgroundColor: '#fafafa', fontWeight: 'bold'}}>
                                                Итого:
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant={'head'}>
                                                Количество
                                            </TableCell>
                                            <TableCell>
                                                {order.products.reduce((accumulator, row) => accumulator + parseInt(row.amount), 0)}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant={'head'}>
                                                Общая цена
                                            </TableCell>
                                            <TableCell>
                                                <Price value={order.amount_total} />
                                            </TableCell>
                                        </TableRow>
                                    </>}
                                    md={<TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell style={{fontWeight: 'bold'}}>Итого:</TableCell>
                                        <TableCell>
                                            {order.products.reduce((accumulator, row) => accumulator + parseInt(row.amount), 0)}
                                        </TableCell>
                                        <TableCell>
                                            <Price value={order.amount_total} />
                                        </TableCell>
                                    </TableRow>}
                                />}
                                actions={[]}
                            />
                        </Grid>

                        <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '40px 0 20px'}} component="legend">Данные доставки</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={[order]}
                                columns={[
                                    {
                                        title: 'Служба',
                                        field: 'ttn_type',
                                        render: (row) => {
                                            switch (row.ttn_type) {
                                                case 'ukrposhta':
                                                    return ' Укрпочта'
                                                case 'novaposhta':
                                                    return ' Новая почта'
                                                case 'meest':
                                                    return ' Meest EXpress'
                                                case 'justin':
                                                    return ' Justin'
                                            };
                                            return '–'
                                        },
                                    },
                                    {
                                        title: 'Метод оплаты',
                                        field: 'payment_type',
                                        render: (row) => {
                                            switch (row.payment_type) {
                                                case 'cod':
                                                    return ' Наложенный платеж'
                                                case 'partial_prepaid':
                                                    return ' Частичная предоплата'
                                                case 'fully_prepaid':
                                                    return ' Полностью оплачено'
                                                case 'online':
                                                    return ' Онлайн оплата через сервис'
                                                case 'prom_oplata':
                                                    return ' Prom-оплата'
                                            }
                                            return '–'
                                        },
                                    },
                                    {
                                        title: 'ТТН',
                                        field: 'ttn',
                                        render: (row) => {
                                            if (row.ttn) {
                                                return (<>
                                                    {row.ttn}
                                                    {row.ttn_type === 'novaposhta' && <>
                                                        {row.delivery_details_novaposhta && row.delivery_details_novaposhta.DateTime && <>
                                                            <br/>
                                                            {dayjs(row.delivery_details_novaposhta.DateTime, 'DD.MM.YYYY').format('DD.MM')}
                                                            &nbsp;/&nbsp;
                                                            <Price
                                                                value={row.delivery_details_novaposhta.DeliveryCost}
                                                            />
                                                        </>}
                                                    </>}
                                                    {row.ttn_type === 'ukrposhta' && <>
                                                        {row.delivery_details_ukrposhta && row.delivery_details_ukrposhta.deliveryDate && <>
                                                            <br/>
                                                            {dayjs(row.delivery_details_ukrposhta.deliveryDate, 'DD.MM.YYYY').format('DD.MM')}
                                                            &nbsp;/&nbsp;
                                                            <Price
                                                                value={row.delivery_details_ukrposhta.deliveryPrice}
                                                            />
                                                        </>}
                                                    </>}
                                                </>);
                                            } else {
                                                if (row.ttn_type === 'novaposhta') {
                                                    return <PermissionModule
                                                      name={'novaposhta'}
                                                    >
                                                        <NewTtnContainer
                                                          order_id={row.id}
                                                          Cost={row.amount_total - row.amount_prepaid}
                                                          ContactRecipient={row.name}
                                                          RecipientsPhone={row.phone}
                                                          Description={''}
                                                          onSubmitRedirect={this.ttnCreated}
                                                        />
                                                    </PermissionModule>
                                                }
                                                if (row.ttn_type === 'ukrposhta') {
                                                    return <PermissionModule
                                                      name={'ukrposhta'}
                                                    >
                                                        <UkrposhtaTtnContainer
                                                          key={row.id}
                                                          order_id={row.id}
                                                          postPay={row.amount_total - row.amount_prepaid}
                                                          declaredPrice={row.amount_total}
                                                          name={row.name}
                                                          phone={row.phone}
                                                          description={row.delivery_details_ukrposhta?.description || ''}
                                                          postcode={row.delivery_details_ukrposhta?.recipient_postcode || ''}
                                                          city={row.delivery_details_ukrposhta?.recipient_address || ''}
                                                          weight={row.products.reduce((accumulator, row) => accumulator + row.variation.product.settings.weight * row.amount, 0).toFixed(2)}
                                                        />
                                                    </PermissionModule>
                                                }
                                            }
                                        },
                                    },
                                    {
                                        title: 'Вид доставки',
                                        render: row => {
                                            if (row.delivery_details_novaposhta && row.delivery_details_novaposhta.ServiceType) {
                                                switch (row.delivery_details_novaposhta.ServiceType) {
                                                    case 'WarehouseWarehouse':
                                                        return 'На склад'
                                                    case 'WarehouseDoors':
                                                        return 'На адрес'
                                                    default:
                                                        return 'Другая'
                                                }
                                            }
                                            if (row.delivery_details_ukrposhta && row.delivery_details_ukrposhta.deliveryType) {
                                                switch (row.delivery_details_ukrposhta.deliveryType) {
                                                    case 'W2W':
                                                        return (<>{!!row.delivery_details_ukrposhta.type ? <>{row.delivery_details_ukrposhta.type},<br/> </> : null}На склад</>)
                                                    case 'W2D':
                                                        return (<>{!!row.delivery_details_ukrposhta.type ? <>{row.delivery_details_ukrposhta.type},<br/> </> : null}На адрес</>)
                                                    default:
                                                        return 'Другая'
                                                }
                                            }
                                            return '–'
                                        }
                                    },
                                    {
                                        title: 'Адрес',
                                        render: (row) => {
                                            if (row.delivery_details_novaposhta && row.delivery_details_novaposhta.CityRecipientName) {
                                                return (<span>{order.delivery_details_novaposhta.CityRecipientName}, {order.delivery_details_novaposhta.RecipientAddressName}</span>);
                                            }
                                            if (row.delivery_details_ukrposhta && row.delivery_details_ukrposhta.recipient_address) {
                                                return (<span>{order.delivery_details_ukrposhta.recipient_address}</span>);
                                            }
                                            return '–';
                                        },
                                    },
                                    {
                                        title: 'Общий вес',
                                        render: (row) => {
                                            if (row.delivery_details_novaposhta && row.delivery_details_novaposhta.Weight) {
                                                return (<span>{order.delivery_details_novaposhta.Weight}</span>);
                                            }
                                            return '–';
                                        },
                                    },
                                ]}
                                actions={[]}
                            />
                        </Grid>

                        {this.state.order.pipeline_id
                            ? this.renderPipelineData()
                            : null
                        }

                        {Object.keys(bankTransactions).length > 0 && <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '40px 0 20px'}} component="legend">Данные оплаты</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={Object.keys(bankTransactions)}
                                columns={[
                                    {
                                        title: 'Дата',
                                        field: 'created_at',
                                        render: (row) => dayjs(bankTransactions[row].created_at).format('DD.MM.YYYY'),
                                        mobileCellProps: {
                                            style: {
                                                backgroundColor: '#fafafa'
                                            },
                                        }
                                    },
                                    {
                                        title: 'Сумма',
                                        field: 'sum',
                                        render: (row) => bankTransactions[row].sum,
                                    },
                                    {
                                        title: 'Комментарий платежа',
                                        field: 'comment',
                                        render: (row) => bankTransactions[row].comment,
                                    },
                                    {
                                        title: 'Комментарий пользователя',
                                        field: 'user_comment',
                                        render: (row) => bankTransactions[row].user_comment,
                                    },
                                ]}
                                actions={[]}
                            />
                        </Grid>}

                        {Object.keys(clientOrders).length > 1 && <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '40px 0 20px'}} component="legend">Все заказы клиента</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={Object.keys(clientOrders)}
                                columns= {[
                                    {
                                        hidden: Object.keys(clientOrders).length < 2,
                                        showInDesktop: true,
                                        headerRender: (row)=> <Checkbox
                                                    checked={selectedClientOrders.length === Object.keys(clientOrders.filter(item => this.isEnabledClientOrder(item))).length}
                                                    onChange={this.handleSelectAllClick}
                                                    indeterminate={selectedClientOrders.length > 0 && 
                                                                   selectedClientOrders.length < Object.keys(clientOrders.filter(item => this.isEnabledClientOrder(item))).length}
                                                /> ,        
                                        render: (row) => <Checkbox
                                                    checked={selectedClientOrders.indexOf(clientOrders[row].id) !== -1} 
                                                    onChange={()=> this.handleClick(clientOrders[row].id)} 
                                                    disabled={!this.isEnabledClientOrder(clientOrders[row])}
                                                 />,
                                    },
                                    {
                                        title: 'Номер заказа',
                                        field: 'company_order_id',
                                        render: (row) => `${clientOrders[row].company_order_id} ${clientOrders[row].id === order.id ? '(текущий)' : ''}`,
                                        mobileCellProps: {
                                            style: {
                                                backgroundColor: '#fafafa'
                                            },
                                        }
                                    },
                                    {
                                        title: 'Дата',
                                        field: 'created_at',
                                        render: (row) => dayjs(clientOrders[row].created_at).format('DD.MM.YYYY'),
                                    },
                                    {
                                        title: 'Сумма заказа',
                                        field: 'amount_total',
                                        render: (row) => clientOrders[row].amount_total,
                                    },
                                    {
                                        title: 'Статус',
                                        field: 'status.name',
                                        render: (row) => clientOrders[row].status.name,
                                    },
                                    {
                                        title: 'Комментарий',
                                        field: 'comment',
                                        render: (row) => clientOrders[row].comment,
                                    },
                                    {
                                        title: 'К объединению',
                                        showInMobile: true,
                                        hidden: Object.keys(clientOrders).length < 2,
                                        render: (row) => <></>,
                                        mobileRender: (row) =>  <Checkbox
                                                        checked={selectedClientOrders.indexOf(clientOrders[row].id) !== -1} 
                                                        onChange={()=> this.handleClick(clientOrders[row].id)} 
                                                        disabled={!this.isEnabledClientOrder(clientOrders[row])}
                                                    />
                                    },
                                ]}
                                customLastRow={(tableClasses) => 
                                    { 
                                        return Object.keys(selectedClientOrders).length > 1 ? 
                                            <ResponsiveComponent
                                                xs={<></>}
                                                md={<TableRow>                                                       
                                                        <TableCell colSpan={6}>
                                                            <CombineOrdersContainer
                                                                onSubmitRedirect={(response) => this.onOrdersCombine(response)}
                                                                orders={selectedClientOrders}
                                                                mainOrder = {selectedClientOrders.find(clientOrder => clientOrder === order.id)}
                                                            />
                                                        </TableCell>
                                                    </TableRow>}
                                            /> : <></>}}                    
                                actions={[]}
                            />
                            {
                                Object.keys(selectedClientOrders).length > 1 ? 
                                <ResponsiveComponent
                                    xs={<div className={classes.iconWithLabel}>
                                        <CombineOrdersContainer  
                                            onSubmitRedirect={(response) => this.onOrdersCombine(response)}                                              
                                            orders={selectedClientOrders}
                                            mainOrder = {selectedClientOrders.find(clientOrder => clientOrder === order.id)}
                                        />
                                    </div>}
                                    md={<></>}
                                /> : <></>
                            }
                        </Grid>}

                        <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '40px 0 20px'}} component="legend">Расходы</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={[
                                    {title: 'Товары', cost: order.products.reduce((accumulator, row) => accumulator + row.price_in * row.amount, 0)},
                                    ...order.costs_list
                                ]}
                                columns={[
                                    {
                                        title: 'Наименование',
                                        field: 'title',
                                        mobileCellProps: {
                                            style: {
                                                backgroundColor: '#fafafa'
                                            },
                                        }
                                    },
                                    {
                                        title: 'Стоимость',
                                        field: 'cost',
                                        render: (row) => <Price value={row.cost} />,
                                    },
                                ]}
                                actions={[]}
                                isAddPanelOpen={this.state.newOrderCostRow.isOpen}
                                addPanel={{
                                    isOpen: this.state.newOrderCostRow.isOpen,
                                    onRowAdd: e => this.createOrderCost(),
                                    onRowClose: e => this.setState({
                                        ...this.state,
                                        newOrderCostRow: this.initNewOrderCostRowState
                                    }),
                                    items: [
                                        (<RemoteAutocompleteWithInput
                                            url={'/api/v1/autocomplete/marketing-cost'}
                                            name={'title'}
                                            value={this.state.newOrderCostRow.title}
                                            onChange={value => this.setState({...this.state, newOrderCostRow: {...this.state.newOrderCostRow, title: value}})}
                                            size={'small'}
                                            errors={this.state.newOrderCostRow.errors}
                                            placeholder={'Наименование'}
                                            fullWidth
                                            variant={'outlined'}
                                        />),
                                        (<Grid container spacing={2} alignItems={'center'}>
                                            <Grid item>
                                                <Input
                                                    name={'cost'}
                                                    value={this.state.newOrderCostRow.cost}
                                                    onChange={({target: {value}}) => this.setState({...this.state, newOrderCostRow: {...this.state.newOrderCostRow, cost: value}})}
                                                    size={'small'}
                                                    type={'number'}
                                                    errors={this.state.newOrderCostRow.errors}
                                                    placeholder={'Стоимость'}
                                                    variant={'outlined'}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <IconButton
                                                    onClick={e => this.createOrderCost()}
                                                >
                                                    <CheckIcon />
                                                </IconButton>
                                                <IconButton
                                                    onClick={e => this.setState({...this.state, newOrderCostRow: this.initNewOrderCostRowState})}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Grid>
                                        </Grid>),
                                    ],
                                }}
                            />
                            <LabelButton
                                title={'Добавить расходы'}
                                icon={<AddCircleIcon color={'primary'}/>}
                                onClick={e => this.setState({...this.state, newOrderCostRow: {...this.state.newOrderCostRow, isOpen: true}})}
                            />
                        </Grid>

                        <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '32px 0 20px'}} component="legend">Связанные задачи</FormLabel>
                            {tasks.length !== 0 && <MaterialTableComponent
                                mobileTableVersion
                                data={tasks}
                                columns={[
                                    {
                                        title: 'Дата и время',
                                        field: 'reminder',
                                        render: row => `${dayjs(row.reminder_start).format('DD.MM.YYYY HH:mm')} - ${dayjs(row.reminder_end).format('HH:mm')}`,
                                        mobileCellProps: {
                                            style: {
                                                backgroundColor: '#fafafa'
                                            },
                                        }
                                    },
                                    {
                                        title: 'Название',
                                        field: 'title',
                                    },
                                    {
                                        title: 'Исполнитель',
                                        field: 'user.name',
                                    },
                                    {
                                        title: 'Описание',
                                        field: 'comment',
                                    },
                                ]}
                                actions={[]}
                            />}
                            <div className={classes.iconWithLabel}>
                                <Typography>Добавить задачу</Typography>
                                <NewTaskContainer
                                    customOpenButton={<AddCircleIcon
                                        className={classes.icon}
                                        color={'primary'}
                                    />}
                                    orderId={order.id}
                                    onSubmitRedirect={(data) => this.addTask(data)}
                                />
                            </div>
                        </Grid>

                        {order.history.length !== 0 && <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '32px 0 20px'}} component="legend">История заказа</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={order.history}
                                columns={[
                                    {
                                        title: 'Дата',
                                        field: 'created_at',
                                        render: (row) => dayjs(row.created_at).format('DD.MM.YYYY HH:mm'),
                                        mobileCellProps: {
                                            style: {
                                                backgroundColor: '#fafafa'
                                            },
                                        }
                                    },
                                    {
                                        title: 'Тип события',
                                        field: 'event',
                                        render: (row) => orderHistoryEventTypes[row.event],
                                    },
                                    {
                                        title: 'Сообщение',
                                        field: 'data.message',
                                        render: (row) => row.data.message,
                                    },
                                    {
                                        title: 'Данные',
                                        field: 'data',
                                        render: (row) => this.orderHistoryDataRender(row.id, context, row.event, row.data, row.file),
                                    },
                                ]}
                                actions={[]}
                            />
                        </Grid>}

                        <PermissionModule
                            name={'documenttemplates'}
                        >
                        <Grid item xs={12} style={{padding: '0px'}}>
                            <FormLabel style={{margin: '32px 0 20px'}} component="legend">Связанные документы</FormLabel>
                            <MaterialTableComponent
                                mobileTableVersion
                                data={order.documents || []}
                                columns={[
                                    {
                                        title: 'Документ',
                                        field: 'file',
                                        render: row => <Grid container alignItems={'center'} justify={'space-between'}>
                                            <Grid item>
                                                <div
                                                    className={classes.documents_title}
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        window.open(row.file, '_blank');
                                                    }}
                                                >
                                                    <img alt={row.file.type} src={`/images/orders/${this.getDocumentType(row.title)}_logo.svg`}/>
                                                    <Typography variant={'body2'}>{row.title}</Typography>
                                                </div>
                                            </Grid>
                                            <Grid item>
                                                <DeleteOutlineOutlinedIcon
                                                    color={'primary'}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={async () => {
                                                        let response = await this.props.deleteOrderDocument(row.id);
                                                        if (response.data) {
                                                            let documents = this.state.order.documents.filter(document => document.id !== response.data.id);
                                                            this.setState({
                                                                ...this.state,
                                                                order: {
                                                                    ...this.state.order,
                                                                    documents: documents,
                                                                }
                                                            })
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>,
                                        hideMobileTitle: true,
                                    },
                                ]}
                                actions={[]}
                            />
                            <NewDocumentContainer
                                orderId={order.id}
                                onSubmitRedirect={this.onDocumentCreate}
                            />
                        </Grid>
                        </PermissionModule>

                        <Grid item xs={12} style={{padding: '0px', marginTop: '24px'}}>
                            <Input
                                value={this.state.comment}
                                onChange={({ target: { value } }) => this.setState({...this.state, comment: value})}
                                variant="outlined"
                                margin="normal"
                                multiline
                                rows={5}
                                size="small"
                                fullWidth
                                label={"Комментарий"}
                                placeholder={"Введите комментарий и нажмите Enter для сохранения"}
                                onKeyDown={(e) => { if (e.key === 'Enter') this.updateComment() }}
                                InputProps={{
                                    endAdornment: <InputAdornment position={'end'}>
                                        <input
                                            accept="image/*,application/pdf"
                                            style={{ display: 'none'}}
                                            id="attach-file-button"
                                            multiple
                                            type="file"
                                            onChange={this.attachOrderFile}
                                            name={'file'}
                                        />
                                        <label htmlFor="attach-file-button">
                                            <IconButton
                                                component="span"
                                            ><AttachFileIcon /></IconButton>
                                        </label>
                                    </InputAdornment>
                                }}
                            />
                            <div className={classes.buttonBox}>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.state.comment && this.updateComment()}
                                >
                                    Добавить
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                }
            </SliderDialog>
        </>)
    }
}
